import { Button, Card, Flex, Text } from '@mantine/core'

import classes from './CallToActionCards.module.css'
import classesScaleWithUsToday from './CallToActionCardsScaleWithUsToday.module.css'

const CallToActionCards = ({
  title,
  description,
  buttonLabel,
  classes,
}: {
  title: string
  description: string
  buttonLabel: string
  classes: Record<string, string>
}) => {
  return (
    <Card className={classes.card} padding='lg' radius='md' withBorder shadow='sm'>
      <Text className={classes.title}>{title}</Text>
      <Text mt='sm' size='md' mih='80px'>
        {description}
      </Text>
      <Flex justify='flex-end'>
        <Button
          className={classes.button}
          mt='md'
          radius='md'
          component='a'
          href='https://ospace.nextgen.group/strategy-meeting'
        >
          {buttonLabel}
        </Button>
      </Flex>
    </Card>
  )
}

export const GenerateMoreLeads = () => {
  return (
    <CallToActionCards
      title='Generate more leads'
      description='Explore our leads generation by creating a new oSpace Program. Chat with one of our Program
        Mangers today.'
      buttonLabel='Create more leads'
      classes={classes}
    />
  )
}

export const ScaleWithUsToday = () => {
  return (
    <CallToActionCards
      title='Scale with us today'
      description='Leveraging the experience and local knowlege of the NEXTGEN Group Sales team allows you to access invaluable customer insights and market data.'
      buttonLabel='Scale now'
      classes={classesScaleWithUsToday}
    />
  )
}
